__webpack_require__.p = "/painter/";